import * as React from "react";
import {
  DefaultButton,
  Dropdown,
  IButtonStyles,
  IDropdownOption,
  IDropdownStyles,
  IStackTokens,
  mergeStyleSets,
  Stack,
} from "@fluentui/react";
import * as Messages from "../../codegen/Messages";

interface ListingPaginationProps {
  showing: {
    fromItems: number;
    toItems: number;
    totalItems: number;
  },
  currentPage: number;
  pageCount: number;
  onPrevious?: (currentPage: number) => void;
  onNext?: (currentPage: number) => void;
  onPageSelect?: (currentPage: number) => void;
}

const buttonStyles: IButtonStyles = {
  root: {
    padding: "0px",
    height: "24px",
  },
};

const dropdownStyles: Partial<IDropdownStyles> = {
  root: { height: "24px" },
  title: {
    height: "24px",
    width: "60px",
    lineHeight: "23px",
  },
  caretDownWrapper: { top: "-3px" },
};

const classNames = mergeStyleSets({
  paginationLabel: {
    lineHeight: "normal",
    fontWeight: 400,
    fontSize: "13px",
    fill: "rgb(0, 0, 0)",
    color: "rgb(50, 49, 48)",
    height: "17px",
    outlineColor: "rgb(50, 49, 48)",
    outlineStyle: "none",
    outlineWidth: "0px",
    textSizeAdjust: "100%",
    marginTop: "4px",
  },
});

export const ListingPagination = ({
  showing,
  currentPage,
  pageCount,
  onPrevious,
  onNext,
  onPageSelect,
}: ListingPaginationProps): JSX.Element => {
  const stackTokens: IStackTokens = { childrenGap: 10 };

  const getPagesOptions = (): IDropdownOption[] => {
    const options: IDropdownOption[] = [];
    for (let i = 1; i <= pageCount; i++) {
      options.push({
        key: i,
        text: i.toString(),
      });
    }
    return options;
  };

  const onPreviousClick = (): void => {
    onPrevious?.(currentPage);
  };

  const onNextClick = (): void => {
    onNext?.(currentPage);
  };

  const onPageChange = (event: React.FormEvent<HTMLDivElement>, item?: IDropdownOption): void => {
    onPageSelect?.(item?.key as number);
  };

  return (
    <Stack
      className="listing-pagination"
      style={{
        bottom: "0px",
        padding: "20px 15px",
        width: "auto",
        backgroundColor: "rgb(255, 255, 255)",
      }}
      horizontal
      tokens={stackTokens}
    >
      <DefaultButton
        styles={buttonStyles}
        text={`< ${Messages.pagination.previous()}`}
        disabled={currentPage === 1}
        onClick={onPreviousClick}
      />
      <div className={classNames.paginationLabel}>{Messages.pagination.page()}</div>
      <Dropdown
        styles={dropdownStyles}
        options={getPagesOptions()}
        defaultSelectedKey={currentPage}
        onChange={onPageChange}
      />
      <div className={classNames.paginationLabel}>{Messages.pagination.of(pageCount.toString())}</div>
      <DefaultButton
        styles={buttonStyles}
        text={`${Messages.pagination.next()} >`}
        onClick={onNextClick}
        disabled={currentPage === pageCount}
      />
      <div
        style={{
          lineHeight: "normal",
          fontWeight: 400,
          fontSize: "13px",
          fill: "rgb(0, 0, 0)",
          color: "rgb(50, 49, 48)",
          height: "17px",
          outlineColor: "rgb(50, 49, 48)",
          outlineStyle: "none",
          outlineWidth: "0px",
          textSizeAdjust: "100%",
          marginTop: "4px",
        }}
      >
        {Messages.listTemplate.showing(
          showing.fromItems.toString(),
          showing.toItems.toString(),
          showing.totalItems.toString(),
        )}
      </div>
    </Stack>
  );
};
